import apiClient from './client';
import type {
  ProviderFinanceAlertSettings,
  ProviderFinanceAlertSettingsUpdate,
  ProviderFinanceDashboard,
  ProviderFinanceRange,
  ProviderFinanceSyncRequest,
  ProviderFinanceSyncResponse,
} from '@/types/providerFinance';

export const providerFinanceApi = {
  getDashboard: (range: ProviderFinanceRange) =>
    apiClient
      .get<ProviderFinanceDashboard>('/provider-finance/dashboard', { params: { range } })
      .then((r) => r.data),

  getAlertSettings: (accountId: string) =>
    apiClient
      .get<ProviderFinanceAlertSettings | null>(
        `/provider-finance/accounts/${encodeURIComponent(accountId)}/alert-settings`,
      )
      .then((r) => r.data),

  putAlertSettings: (accountId: string, body: ProviderFinanceAlertSettingsUpdate) =>
    apiClient
      .put<ProviderFinanceAlertSettings>(
        `/provider-finance/accounts/${encodeURIComponent(accountId)}/alert-settings`,
        body,
      )
      .then((r) => r.data),

  triggerSync: (payload: ProviderFinanceSyncRequest = {}) =>
    apiClient
      .post<ProviderFinanceSyncResponse>('/provider-finance/sync', payload)
      .then((r) => r.data),
};
